import { WORKSHEET_CLASSES } from '../../constants/classNames';
import { joinClassNames } from '../../utils/classNameUtils';

/**
 * A line to write on, or the right answer when the answer key is shown.
 */
export default function AnswerBlank({ answer, showAnswer, isWide = false }) {
  if (showAnswer) return <span className={WORKSHEET_CLASSES.answer}>{answer}</span>;
  return <span className={joinClassNames(WORKSHEET_CLASSES.blank, isWide && WORKSHEET_CLASSES.blankWide)} />;
}
